import { User } from '../../authentication/models/v1-api.interface';

/** Pending invitations do not establish the broker link required by invoices. */
export function canViewInvoices(user: User | null | undefined): boolean {
  return (
    user?.featureInvoicesFlag === true && user.hasPayrollPartnerLink === true
  );
}
